import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import scrollToComponent from 'react-scroll-to-component'
import {
  getSchemaProposalResponsinatorBasicInfo,
  saveProposalQualificationResponsible,
  updateProposalQualificationResponsible,
} from '../../redux/actions/proposalResponsinator'
import { startLoading, doneLoading } from '../../utils/loading'
import { getSchemaSidebar, getSchemaSubProjectSidebar } from '../../redux/actions/sidebar'
import ButtonPanel from '../ButtonPanel'
import QualificationResponsibleForm from './QualificationResponsibleForm'
import QualificationResponsibleView from './QualificationResponsibleView'
import QualificationResponsinatorWidget from './QualificationResponsinatorWidget'
import AttachFilesGranteeContract from '../makeContract/AttachFilesGranteeContract'
import './styles.less'
import notification from '../../utils/notification'
import { deleteGranteeFileById, downloadGranteeFileById } from '../../redux/actions/granteeProperty'
import QualificationResponsinatorTableView from './QualificationResponsinatorTableView'

export default function QualificationResponsibleWidget({
  honorificOptions,
  schema,
  isEditAll,
  responsibleProjectData,
  ...props
}) {
  const { type, isEdit, onChangeIsEdit, showCommandButton, isSubProject } = props
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [formSchema, setFormSchema] = useState(schema)

  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isGranteeFileError, setIsGranteeFileError] = useState(false)

  const [responsibleProjectSchema, setResponsibleProjectSchema] = useState(
    schema?.responsibleProjectData
  )

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if (responsibleProjectData) {
      console.log('responsibleProjectData : ', responsibleProjectData)
      setResponsibleProjectSchema('')
      setTimeout(() => {
        setResponsibleProjectSchema(responsibleProjectData)
      }, 50)
    }
  }, [responsibleProjectData])

  const handleCallService = async (projectId, request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateProposalQualificationResponsible(projectId, request)
      } else {
        console.log('call save.')
        response = await saveProposalQualificationResponsible(projectId, request)
      }

      console.log('response', response)

      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        setResponsibleProjectSchema(response.responsibleProjectData)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let request = {
      id: formSchema.id,
      educationHistory: data.educationHistory,
      experience: data.experience,
      expertiseAreas: data.expertiseAreas,
      // projectOnPropress: data.projectOnPropress || 0,
      // projectOnThaihealth: data.projectOnThaihealth || 0,
      // projectOnOther: data.projectOnOther || 0,
    }

    console.log('request', request)
    handleCallService(projectId, request)
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadGranteeFileById(projectId, fileObj.id, true)
      //  var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.name)
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadGranteeFileById(projectId, fileObj.id, true)
      //  var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.setAttribute('value', fileObj.name)
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      notification.open('error', {
        title: 'แสดงเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const handleDelete = async (id) => {
    startLoading()
    //setIsLoading(true)
    setIsDeleteError(false)
    try {
      console.log('call delete.')
      const status = await deleteGranteeFileById(projectId, id)
      console.log('status', status)
      if (status === 200) {
        let response = await getSchemaProposalResponsinatorBasicInfo(projectId)
        console.log('response', response)
        setFormSchema((state) => ({
          ...state,
          attachFiles: response?.forms?.qualificationResponsible?.attachFiles,
        }))
        setIsDeleteError(false)
      } else {
        setIsDeleteError(response.model.errorMessage || 'ไม่สำเร็จ')
      }
    } catch (e) {
      console.log('e', e)

      if (e?.response?.data) {
        setIsDeleteError(e.response.data.errorMessage)
      } else {
        setIsDeleteError('ไม่สำเร็จ')
      }
    }
    //setIsLoading(false)
    doneLoading()
  }

  const handleOnUploadSuccess = async (res) => {
    let response = await getSchemaProposalResponsinatorBasicInfo(projectId)
    setFormSchema((state) => ({
      ...state,
      attachFiles: response?.forms?.qualificationResponsible?.attachFiles,
    }))
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        bordered
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {isEdit && showCommandButton ? (
          <QualificationResponsibleForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        ) : (
          <QualificationResponsibleView schema={formSchema} />
        )}

        {formSchema?.attachFiles && (
          <>
            <b>{formSchema?.attachFiles?.header}</b>
            <AttachFilesGranteeContract
              schema={formSchema}
              onDelete={handleDelete}
              // onUpdate={onUpdate}
              onDownload={onDownload}
              onPreview={onPreview}
              onUploadSuccess={(e) => handleOnUploadSuccess(e)}
              //   onUploadError={(e) =>
              //     setIsGranteeFileError(e.response.errorMessage + ' อัพโหลดไม่สำเร็จ')
              //   }
              isEditErr={isEditErr}
              isUploadErr={isUploadErr}
              isDeleteError={isDeleteError}
              loading={isLoading}
              disabledForm={formSchema.disabled}
            />
            <br />
          </>
        )}

        {isEdit ? (
          <>
            {/* isEdit  true */}
            <ButtonPanel
              isDisabled={isLoading}
              isEdit={isEdit}
              isError={isError}
              buttonText={formSchema.buttonText}
              onSave={handleSubmit(onSubmit)}
              onCancel={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
              }}
              onEdit={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
            />
            <hr />
            <QualificationResponsinatorWidget schema={responsibleProjectSchema} />
          </>
        ) : (
          <>
            {responsibleProjectSchema && (
              <QualificationResponsinatorTableView
                schema={responsibleProjectSchema.values}
                header={responsibleProjectSchema.header}
              />
            )}
            {!formSchema.disabled && (
              <>
                <hr />
                <ButtonPanel
                  isDisabled={isLoading}
                  isEdit={isEdit}
                  isError={isError}
                  buttonText={formSchema.buttonText}
                  onSave={handleSubmit(onSubmit)}
                  onCancel={() => {
                    setIsError(false)
                    onChangeIsEdit(!isEdit)
                  }}
                  onEdit={() => {
                    setIsError(false)
                    onChangeIsEdit(!isEdit)
                    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                  }}
                />
              </>
            )}
          </>
        )}
      </Panel>
    </>
  )
}
